import { BaseField } from '../base-field';

export class CpfCnpjField<T = any> extends BaseField<T> {
    public readonly: boolean | ((value: T) => boolean) = false;
    public placeholder: string = '';

    constructor(init: Partial<CpfCnpjField<T>>) {
        super('CpfCnpj', init);
        Object.assign(this, init);
        if (!init.css) {
            this.css = 'col-sm-12 col-md-6 col-lg-4';
        }
    }
}